import { put } from 'redux-saga/effects';
import PersonalApi from "../services/personalApi";
import { adaptPersonalGet, adaptPersonalPut, adaptTariff, adaptDpScheme } from '../services/personalAdapter';
import { UPDATE_PERSONAL_DETAIL, SET_PERSONAL_INFO_DROPDOWN, UPDATE_INCOMEPROOF_DETAIL, SET_INCOMEPROOF_INFO_DROPDOWN, GET_NOMINEE_GENDER, GET_NOMINEE_RELATIONSHIP, GET_NOMINEE_TYPE, GET_PERSONAL_DETAILS_USEQUITY, UPDATE_PERSONAL_DETAILS_USEQUITY, SET_PERSONAL_INFO_USEQUITY_DROPDOWN, GET_PERSONAL_INFO_USEQUITY, UPDATE_PERSONAL_INFO_USEQUITY, GET_NOMINEE_DOCUMENT_TYPE, GET_SELECTEDSEGMENT, GET_DPTARIFF, SET_DP_SCHEME } from '../redux/types/personal';
import { setLoading, clearLoading } from '../redux/actions/loader';
import { RESPONSE_ERROR_SNACK_OPEN } from '../redux/types/responseError';
import { apiErrorResponse } from '../helper/constant';
import { PRIMARY_APPLICANT_ADDRESS } from '../redux/types/nominee';

let api = new PersonalApi();

// Stage 9 (eKYC 3.0): saga rerouted from legacy /personalDeatils/get to
// new GET /personal-details. Adapter synthesises legacy { PersonalDetails,
// DropDownValues, ... } shape so all dadPersonal/dadPersonalFunctional/etc.
// callers see no contract change. Phase D retires this saga once those
// screens read the BE shape directly.
export function* getPersonalInfo({ type, payload, resolve, reject }) {
    try {
        let responsePayload = {};

        yield put(setLoading());

        // services/index.js unwrapEnvelope returns envelope.data on success.
        // getMergedBeData() also hydrates the occupation / annual-income /
        // trading-experience option lists from GET /lookups/{category} so their
        // BE codes match the saved value and the chips prefill (see personalApi).
        const beData = yield api.getMergedBeData();

        yield put(clearLoading());
        const { personalDetails, dropDownValues } = adaptPersonalGet(beData || {});
        yield put({ type: UPDATE_PERSONAL_DETAIL, payload: personalDetails });
        yield put({ type: SET_PERSONAL_INFO_DROPDOWN, payload: dropDownValues });
        // Nominee dropdowns + selected-segment / DP-tariff are NON-DAD wave 2;
        // emit empty defaults so reducers stay shaped.
        yield put({ type: GET_NOMINEE_GENDER, payload: [] });
        yield put({ type: GET_NOMINEE_RELATIONSHIP, payload: [] });
        yield put({ type: PRIMARY_APPLICANT_ADDRESS, payload: {} });
        yield put({ type: GET_NOMINEE_TYPE, payload: [] });
        yield put({ type: GET_NOMINEE_DOCUMENT_TYPE, payload: [] });
        yield put({ type: GET_SELECTEDSEGMENT, payload: '' });
        // Brokerage charges modal — adaptTariff reads the three sibling fields
        // (tariffData / tariffType / partnerTariffData) and normalises them to
        // { type, standard, partner } ready for FundTable.
        yield put({ type: GET_DPTARIFF, payload: adaptTariff(beData) });
        // CRM (branch) "DP Scheme" dropdown — adaptDpScheme yields show:false for
        // everyone else (null key), so non-CRM journeys are untouched.
        yield put({ type: SET_DP_SCHEME, payload: adaptDpScheme(beData) });
        resolve && resolve({ STATUS: '1', PersonalDetails: personalDetails });
    } catch (e) {
        console.log('getPersonalInfo (new BE) error', e);
        yield put(clearLoading());
        const msg = (e && (e.message || (e.errors && e.errors[0] && e.errors[0].message))) || apiErrorResponse;
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: { type: 'error', message: msg } });
        reject && reject(e);
    }
}

export function* getIncomeProofDetails({ type, payload, resolve, reject }) {
    try {
        let responsePayload = {};

        yield put(setLoading());

        let response = yield api.getIncomeProofDetails(payload)

        yield put(clearLoading());
        console.log('getIncomeProofDetails_response', response.data.Data.getIncomeProofDetails);
        if (response.data && response.data.Status) {
            if (response.data.Data) {
                yield put({ type: UPDATE_INCOMEPROOF_DETAIL, payload: response.data.Data.getIncomeProofDetails })//input fields values
                yield put({ type: SET_INCOMEPROOF_INFO_DROPDOWN, payload: response.data.Data.DropDownValues })//drop down values of personal details form

                resolve && resolve(response.data.Data);
            } else {
                responsePayload = { type: "error", message: response.data.Data.Message }
                yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
            }
        }
        else {
            if (response.data.code !== 401) {
                responsePayload = { type: "error", message: response.data.Message }
                yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
            }
        }
    } catch (e) {
        console.log('catch', e)
        let responsePayload = {};
        responsePayload = { type: "error", message: apiErrorResponse }
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
    }
}


// Stage 9 (eKYC 3.0): saga rerouted to PUT /personal-details. Payload shape
// is the legacy { data: {...}, PersonalDetails: {...} } object that DadPersonal
// builds; we translate `data` → BE PUT body via adaptPersonalPut, and resolve
// with a STATUS:'1'+legacy-shape envelope so downstream callers branch on
// `response.STATUS === '1'` unchanged. Routing is read off the journey
// reducer (auto-applied by unwrapEnvelope) — callers should switch to
// `routeForJourney(getJourney(),...)` instead of `response.showFatherSpouse`.
export function* updatePersonalInfo({ type, payload, resolve, reject }) {
    try {
        const { data: legacyData, PersonalDetails } = payload || {};
        yield put(setLoading({ message: '' }));

        const saveResult = yield api.save(adaptPersonalPut(legacyData || {}));

        yield put(clearLoading());
        if (PersonalDetails) {
            yield put({ type: UPDATE_PERSONAL_DETAIL, payload: PersonalDetails });
        }
        // Resolve in legacy `Data[0]` shape so call sites keep working —
        // `response.STATUS === '1'` is the success flag, no `MESSAGE` on success.
        resolve && resolve({
            STATUS: '1',
            MESSAGE: 'Personal details saved',
            stage10Required: !!(saveResult && saveResult.stage10Required),
            fnoSelected: !!(saveResult && saveResult.fnoSelected),
            // Segment Selection API: PUT echoes exactly what was stored, which
            // may differ from the request (staff clearing, legacy expansion
            // while the split rollout flag is off).
            currencySelected: !!(saveResult && saveResult.currencySelected),
            commoditySelected: !!(saveResult && saveResult.commoditySelected),
            derivativesSelected: !!(saveResult && (saveResult.derivativesSelected
                || saveResult.fnoSelected || saveResult.currencySelected || saveResult.commoditySelected)),
            // showFatherSpouse defaults to "0" (no Father/Spouse hop) since BE
            // option (b) collapsed Father/Spouse into the PUT body; callers
            // that branch on this still work.
            showFatherSpouse: '0',
        });
    } catch (e) {
        console.log('updatePersonalInfo (new BE) error', e);
        yield put(clearLoading());
        const msg = (e && (e.message || (e.errors && e.errors[0] && e.errors[0].message))) || apiErrorResponse;
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: { type: 'error', message: msg } });
        reject && reject(e);
    }
}

export function* updatePersonalOtherDetails({ type, payload, resolve, reject }) {
    try {
        let responsePayload = {};

        yield put(setLoading());

        let response = yield api.updatePersonalOtherDetails(payload)

        yield put(clearLoading());
        console.log('personal response', response);
        if (response.data && response.data.Status) {
            if (response.data.Data) {
                resolve && resolve(response.data.Data);
            } else {
                responsePayload = { type: "error", message: response.data.Data.Message }
                yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
            }
        }
        else {
            if (response.data.code !== 401) {
                responsePayload = { type: "error", message: response.data.Message }
                yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
            }
        }
    } catch (e) {
        console.log('catch', e)
        let responsePayload = {};
        responsePayload = { type: "error", message: apiErrorResponse }
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
    }
}

export function* getPersonalDetailsUsEquity({ type, payload, resolve, reject }) {
    try {
        let responsePayload = {};

        yield put(setLoading());
        console.log('personal request', payload);
        let response = yield api.getPersonalDetailsUsEquity(payload)

        yield put(clearLoading());
        console.log('personal response', response);
        if (response.data && response.data.Status) {
            if (response.data.Data) {
                // yield put({ type: GET_PERSONAL_DETAILS_USEQUITY, payload: response.data.Data.GETPERSONALDETAILS_USEQUITY })//input fields values                
                yield put({ type: SET_PERSONAL_INFO_USEQUITY_DROPDOWN, payload: response.data.Data.USEQUITYDROPDOWN })//drop down values of personal details form                
                yield put({ type: GET_PERSONAL_INFO_USEQUITY, payload: response.data.Data.GETPERSONALDETAILS_USEQUITY })//input fields values
                // yield put({ type: UPDATE_PERSONAL_DETAIL, payload: response.data.Data.PersonalDetails })//input fields values
                // yield put({ type: SET_PERSONAL_INFO_DROPDOWN, payload: response.data.Dassta.DropDownValues })//drop down values of personal details form
                // yield put({ type: GET_NOMINEE_GENDER, payload: response.data.Data.GETNOMINEEGENDER })//drop down values of nominee details form
                // yield put({ type: GET_NOMINEE_RELATIONSHIP, payload: response.data.Data.GETNOMINEERELATIONSHIP })//drop down values of nominee details form
                // yield put({ type: PRIMARY_APPLICANT_ADDRESS, payload: response.data.Data.PRIMARYAPPLICANTADDRESS[0] })
                // yield put({ type: GET_NOMINEE_TYPE, payload: response.data.Data.NomineeType })
                // resolve && resolve(response.data.Data);
            } else {
                responsePayload = { type: "error", message: response.data.Data.Message }
                yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
            }
        }
        else {
            if (response.data.code !== 401) {
                responsePayload = { type: "error", message: response.data.Message }
                yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
            }
        }
    } catch (e) {
        console.log('catch', e)
        let responsePayload = {};
        responsePayload = { type: "error", message: apiErrorResponse }
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
    }
}


export function* updatePersonalDetailsUsEquity({ type, payload, resolve, reject }) {
    try {
        let responsePayload = {};
        let { data, PersonalDetails } = payload;
        // yield put(setLoading({ message: "Generating some more exciting offers for you" }));
        yield put(setLoading({ message: '' }));

        let response = yield api.updatePersonalDetailsUsEquity(data)

        yield put(clearLoading());
        console.log('personal update response', response);
        if (response.data && response.data.Status) {
            if (response.data.Data) {
                yield put({ type: UPDATE_PERSONAL_INFO_USEQUITY, payload: response.data.Data })//input fields values
                resolve && resolve(response.data.Data[0]);
            }
            else {
                responsePayload = { type: "error", message: response.data.Data.Message }
                yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
            }
        }
        else {
            responsePayload = { type: "error", message: response.data.Message }
            yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
        }
    } catch (e) {
        console.log('catch', e)
        let responsePayload = {};
        responsePayload = { type: "error", message: apiErrorResponse }
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
    }
}
